import {ModuleWithProviders, NgModule} from '@angular/core';
import {LeafletDrawDirective} from './core/leaflet-draw.directive';
import {LeafletModule} from './leaflet.module';


@NgModule({
  imports: [
    LeafletModule
  ],
  exports: [
    LeafletDrawDirective
  ],
  declarations: [
    LeafletDrawDirective
  ]
})
export class LeafletDrawModule {

  static forRoot(): ModuleWithProviders<LeafletDrawModule> {
    return {ngModule: LeafletDrawModule, providers: []};
  }

}
